import React from 'react';
import { generatePath } from 'react-router';

import { Icon } from '@epoch-ui/components/Icon';
import { LinkButton } from '@epoch-ui/components/LinkButton';
import { DASHBOARD_EVENT_CHECKIN_MANAGER_ROUTE } from 'constants/routes';

type CheckInLinkButtonProps = {
  eventId: number;
  sessionId?: string | null;
};

const CheckInLinkButton: React.FC<CheckInLinkButtonProps> = ({ eventId, sessionId }) => (
  <LinkButton
    variant="secondary"
    size="xxs"
    className="tw-rounded-xl"
    href={generatePath(DASHBOARD_EVENT_CHECKIN_MANAGER_ROUTE, {
      id: eventId.toString(),
      sessionId: sessionId ?? null
    })}
  >
    <Icon name="circle-check" size={16} className="tw-mr-1" />
    Check-in
  </LinkButton>
);

export { CheckInLinkButton };
